import styled from "styled-components";

export const Container = styled.button`
     color: var(--color-second-light);
     background-color: var(--bg-button);
     width: 152px;
     height: 40px;
     font-size: 1rem;
     border-radius: 15px;
     box-shadow: 2px 2px 4px 0px #000000;
`;

